module.exports = __webpack_public_path__ + "static/img/8.5561046.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/8.png
// module id = G5W+
// module chunks = 0